/* NukkadTales — Hero Gul init
   Loaded via layout/theme.liquid (defer, after nukkad-gul.js).
   Section inline scripts are blocked by Foxify — this file is the
   only safe place to run hero-specific JavaScript.
*/
(function () {
  'use strict';

  /* Sentinel: tells the section's inline fallback script to stand down.
     Set immediately — before any async work — so it's always true by the
     time DOMContentLoaded fires (which runs after defer scripts). */
  window._ntHeroActive = true;

  var _isReturn = false;
  try { _isReturn = !!localStorage.getItem('nt_visited'); } catch(e) {}
  try { if (!_isReturn) localStorage.setItem('nt_visited', '1'); } catch(e) {}

  var PERCH = { fx: 0.55, fy: 0.361 };
  var FOOTF = 0.811, CXF = 0.463;
  var GD = 133;

  var heroGulRoot, branchImg, taphint, heroGul, flyBusy = false;
  var skipEl, _speaking = null;
  var _kalReady = Promise.resolve();

  function getGD() {
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--gul-d').trim()) || 133;
  }

  function syncGulD() {
    var v = getGD();
    if (v !== GD) {
      GD = v;
      if (heroGul && heroGulRoot) {
        heroGul.D = v;
        heroGulRoot.style.setProperty('--D', v + 'px');
        heroGulRoot.style.width  = v + 'px';
        heroGulRoot.style.height = v + 'px';
        try { heroGul.frame(heroGul.base); } catch(e) {}
      }
    }
  }

  function perchXY() {
    GD = getGD();
    var hero = document.getElementById('nt-hero');
    var branch = branchImg || document.getElementById('nt-branchImg');
    if (!hero) return null;
    var hr = hero.getBoundingClientRect();
    if (!hr.width || !hr.height) return null;
    var isDesk = hr.width >= 768;
    if (branch && branch.naturalWidth > 0) {
      var br = branch.getBoundingClientRect();
      if (br.height > 10) {
        return {
          x: (br.left - hr.left) + br.width * (isDesk ? 0.50 : 0.60) - CXF * GD,
          y: (br.top  - hr.top)  + br.height * 0.45 - FOOTF * GD
        };
      }
    }
    return {
      x: hr.width  * (isDesk ? 0.76 : 0.68) - CXF  * GD,
      y: hr.height * (isDesk ? 0.62 : 0.74) - FOOTF * GD
    };
  }

  function setGulPos(x, y) {
    heroGulRoot.style.left = x + 'px';
    heroGulRoot.style.top  = y + 'px';
  }

  var STORIES = null;
  /* Fetch live tales immediately — will be ready long before first click */
  var _talesReady = fetch('https://cozy-dieffenbachia-95eb4b.netlify.app/.netlify/functions/nt-tales')
    .then(function(r) { return r.ok ? r.json() : Promise.reject(); })
    .then(function(arr) {
      var active = arr
        .filter(function(t) { return t.active !== false; })
        .sort(function(a, b) { return (a.priority || 999) - (b.priority || 999); })
        .map(function(t) { return t.text; });
      if (active.length) STORIES = active;
    })
    .catch(function() {});

  function getStories() {
    if (!STORIES) {
      STORIES = window.NT_LIVE_STORIES && window.NT_LIVE_STORIES.length
        ? window.NT_LIVE_STORIES
        : [
            "One papa never says 'I love you'. {pause} He says 'khana khaya?' {blink2} Same thing only.",
            "One aunty has 'sabr' written near her kitchen. {pause} She says it has saved many chappals from flying. {giggle}",
            "One watchman greets every single person by name. {pause} Two hundred names he knows. {blink} Everyone walks in a little taller.",
            "Two sisters fight on the phone every day. {pause} But if one doesn't call, {tilt} the other one panics. {giggle} Love only, in loud form.",
            "One boy hung 'welcome home' on the door for his mother, back from hospital. {pause} She cried right there at the door. {blink} Happy crying."
          ];
    }
    return STORIES;
  }
  var OPENERS = [
    "Okay, okay… {pause} one tale.",
    "One more? {giggle} You like them, na…",
    "Arrey, again? {tilt} Okay okay, fine…",
    "Hmm, which one… {pause} okay. This one.",
    "{giggle} You and me, same only. {pause} Listen…"
  ];
  var stIdx = 0;

  async function heroEntrance() {
    if (!heroGul || flyBusy) return;
    syncGulD();
    flyBusy = true;
    heroGul.root.classList.remove('breath');
    if (taphint) taphint.classList.remove('show');

    var p = perchXY();
    if (!p) { flyBusy = false; return; }
    var sx = (branchImg ? branchImg.offsetWidth : 400) + 260;
    var sy = p.y - 150;

    GD = getGD();
    if (heroGul.D !== GD) {
      heroGul = window.makeGul(heroGulRoot, GD);
      if (!heroGul) { flyBusy = false; return; }
    }

    var ic = document.getElementById('nt-sndIco');
    if (ic) { ic.style.left = (p.x - 26) + 'px'; ic.style.top = (p.y + GD * 0.55) + 'px'; }

    setGulPos(sx, sy);
    heroGulRoot.style.visibility = 'visible';
    heroGul.flip.style.transform = 'scaleX(-1)';

    var fa = 0;
    var fl = setInterval(function () {
      heroGul.frame(fa ? window.F.fdn : window.F.fup);
      if (fa && window.flapSnd) window.flapSnd();
      fa ^= 1;
    }, 120);

    var dur = 1500, t0 = performance.now();
    await new Promise(function (res) {
      function st(now) {
        var q = Math.min(1, (now - t0) / dur);
        var e = q < .5 ? 2*q*q : 1 - Math.pow(-2*q+2,2)/2;
        setGulPos(sx + (p.x-sx)*e, sy + (p.y-sy)*e - Math.sin(Math.PI*q)*60);
        heroGul.leanEl.style.transform = 'rotate(' + (4*(1-e)) + 'deg)';
        if (q < 1) requestAnimationFrame(st); else res();
      }
      requestAnimationFrame(st);
    });

    clearInterval(fl);
    heroGul.frame(window.F.sit);
    heroGul.leanEl.style.transform = 'rotate(0)';
    heroGul.sp.style.transition = 'transform .12s ease';
    heroGul.sp.style.transform = 'scaleY(.86) scaleX(1.05)';
    await window.wait(120);
    heroGul.sp.style.transform = 'scaleY(1)';
    await window.wait(320);
    heroGul.setFace(window.F.closed);
    heroGul.flip.style.transform = 'scaleX(1)';
    heroGul.root.classList.add('breath');
    await window.wait(380);

    (async function () {
      await _kalReady;
      heroGul.instant("Hi! I'm Gul.");
      heroGul.setFace(window.F.happy);
      var bbl = document.getElementById('nt-bubble');
      var introRun = heroGul.run;
      await heroGul.gest('wave');
      heroGul.setFace(window.F.closed);
      await window.wait(900);
      if (heroGul.run !== introRun || heroGul._busy) return;
      if (bbl) bbl.classList.remove('show');
      await window.wait(320);
      if (heroGul.run !== introRun || heroGul._busy) return;
      await heroGul.tell("Remember me? {blink} Every nukkad, every windowsill — I'm there only.");
      introRun = heroGul.run;
      await window.wait(600);
      if (heroGul.run !== introRun || heroGul._busy) return;
      if (bbl) bbl.classList.remove('show');
      await window.wait(320);
      if (heroGul.run !== introRun || heroGul._busy) return;
      await heroGul.tell("I hear every word you say… {pause} So many tales I've got. {tilt} But the good ones — {pause} I only tell when someone asks. {giggle}");
      if (taphint) taphint.classList.add('show');
    })();

    if (!heroGul._bl) { heroGul._bl = 1; blinkLoop(heroGul); }

    /* Rotate headline/lede if tales data is available */
    var tales = window.NT_HERO_TALES || [];
    if (tales.length > 1) {
      var hi = 0;
      setInterval(function () {
        hi = (hi + 1) % tales.length;
        var h1    = document.getElementById('nt-h1rot');
        var h1em  = document.getElementById('nt-h1em');
        var h1l2  = document.getElementById('nt-h1line2');
        var lede  = document.getElementById('nt-lede');
        if (h1) { h1.classList.add('out'); setTimeout(function(){ h1.textContent = tales[hi].quote; h1.classList.remove('out'); }, 400); }
        setTimeout(function(){
          if (h1em && tales[hi].em != null) h1em.textContent = tales[hi].em;
          if (h1l2) { h1l2.textContent = tales[hi].line2 || ''; h1l2.style.display = tales[hi].line2 ? '' : 'none'; }
          if (lede) lede.textContent = tales[hi].for;
        }, 400);
      }, 4800);
    }

    flyBusy = false;
  }

  function blinkLoop(g) {
    setTimeout(function () {
      if (!g._j) { g.frame(window.F.blink); setTimeout(function(){ if(!g._j) g.frame(g.base); }, 150); }
      blinkLoop(g);
    }, 3200 + Math.random() * 1800);
  }

  function placeGulAtPerch() {
    if (!heroGul) return;
    syncGulD();
    var p = perchXY();
    if (!p) return;
    setGulPos(p.x, p.y);
    var ic = document.getElementById('nt-sndIco');
    if (ic) { ic.style.left = (p.x - 26) + 'px'; ic.style.top = (p.y + GD * 0.55) + 'px'; }
    heroGulRoot.style.visibility = 'visible';
    heroGul.flip.style.transform = 'scaleX(1)';
    heroGul.setFace(window.F ? window.F.closed : 0);
    heroGul.root.classList.add('breath');
  }

  function showSkip(mode) {
    _speaking = mode;
    if (taphint) taphint.classList.remove('show');
    if (skipEl) {
      skipEl.textContent = mode === 'intro' ? 'skip intro ×' : 'skip tale ×';
      skipEl.classList.add('show');
    }
  }

  function idleUI(label) {
    _speaking = null;
    if (skipEl) skipEl.classList.remove('show');
    if (taphint) { taphint.textContent = label || 'tap Gul for a tale'; taphint.classList.add('show'); }
  }

  function initHero() {
    heroGulRoot = document.getElementById('nt-heroGul');
    branchImg   = document.getElementById('nt-branchImg');
    taphint = document.getElementById('nt-taphint');
    skipEl  = document.getElementById('nt-skip');
    if (!heroGulRoot || !branchImg) return;

    GD = getGD();
    heroGul = window.makeGul(heroGulRoot, GD);
    if (!heroGul) return;

    window.ntHeroEntrance = heroEntrance;

    requestAnimationFrame(syncGulD);

    /* Start Kalam font-ready check immediately — runs in parallel with branch
       image load and sprite decode so the font is ready before bird is visible.
       Catch any rejection (e.g. broken font URL) so tell() always fires. */
    _kalReady = document.fonts
      ? Promise.all([
          document.fonts.load('400 16px Kalam').catch(function() {}),
          document.fonts.load('700 16px Kalam').catch(function() {})
        ])
      : Promise.resolve();

    /* Place Gul at perch immediately — no fly-in animation */
    function tryPlace() {
      if (heroGulRoot.style.visibility === 'visible') return;
      if (perchXY()) { placeGulAtPerch(); startCharacter(); return; }
      var attempts = 0;
      var t = setInterval(function () {
        attempts++;
        if (heroGulRoot.style.visibility === 'visible') { clearInterval(t); return; }
        if (perchXY() || attempts > 160) { clearInterval(t); placeGulAtPerch(); startCharacter(); }
      }, 50);
    }

    function startCharacter() {
      if (!heroGul._bl) { heroGul._bl = 1; blinkLoop(heroGul); }
      (async function () {
        await _kalReady;
        heroGul.instant(_isReturn ? "Hey, you're back!" : "Hi! I'm Gul.");
        showSkip('intro');
        heroGul.setFace(window.F.happy);
        var bbl = document.getElementById('nt-bubble');
        var introRun = heroGul.run;
        await heroGul.gest('wave');
        heroGul.setFace(window.F.closed);
        if (_isReturn) {
          await window.wait(700);
          if (heroGul.run !== introRun || heroGul._busy) return;
          if (bbl) bbl.classList.remove('show');
          await window.wait(320);
          if (heroGul.run !== introRun || heroGul._busy) return;
          await heroGul.tell("Happy to see a familiar face. {blink} Ready for another tale? {giggle}");
        } else {
          await window.wait(900);
          if (heroGul.run !== introRun || heroGul._busy) return;
          if (bbl) bbl.classList.remove('show');
          await window.wait(320);
          if (heroGul.run !== introRun || heroGul._busy) return;
          await heroGul.tell("Remember me? {blink} Every nukkad, every windowsill — I'm there only.");
          introRun = heroGul.run;
          await window.wait(600);
          if (heroGul.run !== introRun || heroGul._busy) return;
          if (bbl) bbl.classList.remove('show');
          await window.wait(320);
          if (heroGul.run !== introRun || heroGul._busy) return;
          await heroGul.tell("I hear every word you say… {pause} So many tales I've got. {tilt} But the good ones — {pause} I only tell when someone asks. {giggle}");
        }
        idleUI('tap Gul for a tale');
      })();
    }

    if (branchImg.complete && branchImg.naturalWidth > 0) {
      tryPlace();
    } else {
      branchImg.addEventListener('load', tryPlace, { once: true });
    }

    /* Tell a tale — called from sprite click OR taphint click */
    async function doTale() {
      if (heroGul._busy) return; heroGul._busy = true;
      showSkip('tale');
      if (window.chirp) window.chirp();
      heroGul.setFace(window.F.happy);
      heroGul.flip.classList.add('gigA');
      await _talesReady;
      await window.wait(320);
      heroGul.flip.classList.remove('gigA');
      var stories = getStories();
      await heroGul.tell(OPENERS[stIdx < OPENERS.length ? stIdx : 3 + (stIdx % 2)]);
      await window.wait(260);
      await heroGul.tell(stories[stIdx++ % stories.length]);
      heroGul.setFace(window.F.closed);
      heroGul._busy = false;
      idleUI('tap Gul for a tale');
    }
    heroGul.sp.addEventListener('click', function () { doTale(); });
    if (taphint) taphint.addEventListener('click', function () { doTale(); });
    if (skipEl) skipEl.addEventListener('click', function () {
      heroGul.run++;
      heroGul.mouth(false);
      var bbl = document.getElementById('nt-bubble');
      if (bbl) bbl.classList.remove('show');
      heroGul._busy = false;
      idleUI('tap Gul for a tale');
    });

    var ctaBtn = document.getElementById('nt-cta-scroll');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        var wrap = document.querySelector('.nukkad-hero-wrap');
        var next = wrap ? wrap.nextElementSibling : null;
        if (next) next.scrollIntoView({ behavior: 'smooth' });
      });
    }

    window.addEventListener('resize', function () {
      syncGulD();
      if (!flyBusy) placeGulAtPerch();
    });

    /* Parallax */
    var plxEls = document.querySelectorAll('#nt-scene .plx');
    var mx = 0, my = 0, tx = 0, ty = 0, sc = 0;
    document.addEventListener('mousemove', function (e) {
      tx = ((e.clientX / window.innerWidth) - 0.5) * 2;
      ty = ((e.clientY / window.innerHeight) - 0.5) * 2;
    }, { passive: true });
    window.addEventListener('scroll', function () { sc = window.scrollY; }, { passive: true });
    (function tick() {
      mx += (tx - mx) * 0.05; my += (ty - my) * 0.05;
      plxEls.forEach(function (l) {
        var d = +l.dataset.d;
        l.style.transform = 'translate3d(' + ((-mx*26*d).toFixed(2)) + 'px,' + ((-my*14*d - sc*d*0.18).toFixed(2)) + 'px,0)';
      });
      requestAnimationFrame(tick);
    })();
  }

  /* Both scripts load async so Gul can start the moment the hero section
     markup is parsed — long before the rest of the page finishes. Poll for
     makeGul (nukkad-gul.js may still be downloading) and the hero element
     (parser may not have reached the hero section yet). */
  (function boot() {
    if (window.makeGul && document.getElementById('nt-heroGul') && document.getElementById('nt-branchImg')) {
      initHero();
      return;
    }
    if (document.readyState === 'complete' && !document.getElementById('nt-heroGul')) return; /* not the home page */
    setTimeout(boot, 40);
  })();
})();
